import React, { useState } from "react";
import { TextField, Input, InputAdornment, IconButton, FormControl, InputLabel } from "@mui/material";
import Visibility from '@mui/icons-material/Visibility';
import VisibilityOff from '@mui/icons-material/VisibilityOff';
import CheckIcon from '@mui/icons-material/Check';

export default function Setdatacard () {
    
    const [value, setValue] = useState(0)
    
    const handleonchange = (e) => {
        setValue(e.target.value)
    }
    return(
        <div style={{height: 'calc(100% - 55px)', width: 'calc(100% - 15px)', padding: '10px', overflow: 'auto', textAlign: 'center', justifyContent: 'center', alignItems: 'center'}}>
            <FormControl sx={{ m: 1, width: '90%' }} variant="standard">
                <InputLabel htmlFor="standard-adornment-password">Set Value</InputLabel>
                    <Input
                        label= "Set Value"
                        variant="standard"
                        focused
                        style={{width: '100%'}}
                        //type="number"
                        endAdornment={
                            <InputAdornment position="end">
                                <IconButton
                                    aria-label={
                                        'Test' //showPassword ? 'hide the password' : 'display the password'
                                    }
                                    //onClick={handleClickShowPassword}
                                    //onMouseDown={handleMouseDownPassword}
                                    //onMouseUp={handleMouseUpPassword}
                                >
                                    {<CheckIcon />}
                                </IconButton>
                            </InputAdornment>
                        }
                        value={value}
                        onChange={handleonchange}
                    />
            </FormControl>
        </div>
    )
}
